import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../../utils/analytics';
import { COOKIE_CONSENT_MAX_AGE, getCookieConsent, subscribeCookieConsent } from '../../utils/cookieNotice';

export default function Analytics() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    let expiryTimer;
    const update = () => {
      clearTimeout(expiryTimer);
      analytics.page(pathname);
      const consent = getCookieConsent();
      if (consent?.analytics) {
        const remaining = Date.parse(consent.timestamp) + COOKIE_CONSENT_MAX_AGE - Date.now();
        expiryTimer = setTimeout(update, Math.min(Math.max(remaining, 1), 2147483647));
      }
    };
    const click = event => {
      const link = event.target.closest?.('a[href]');
      if (!link || event.defaultPrevented) return;
      const url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin && url.pathname === '/register' && pathname !== '/register') {
        analytics.event('start_registration', pathname);
      }
    };
    update();
    const unsubscribe = subscribeCookieConsent(update);
    window.addEventListener('focus', update);
    document.addEventListener('click', click, true);
    return () => {
      clearTimeout(expiryTimer);
      unsubscribe();
      window.removeEventListener('focus', update);
      document.removeEventListener('click', click, true);
    };
  }, [pathname]);
  return null;
}
